module.exports = __webpack_public_path__ + "static/logo-white-f6418fa3ee5d3c3241d969df8052dd11.svg";